angular.module('acme.common.service.reservation', [
  'acme.common.service.utils'
]).provider('ReservationApiService', ReservationApiServiceProvider);

/**
 * Service responsible for managing call to the reservationsAPI
 * @constructor
 * @param {String} endpoint - the endpoint used
 * @param {Object} $http - angular $http service
 * @param {Object} $q - angular $q service
 * @param {Function} debounce - acme's debounce utility function
 * @return {ReservationApiService} instance
 */
function ReservationApiService(endpoint, $http, $q, debounce) {
  return {
    detail: detail,
    create: create,
    update: debounce(update, 300),
    cancel: cancel
  };
  /**
   * @property {String} id - reservation id
   */
  /**
   * Calls the create endpoint
   * @memberOf ReservationApiService
   * @public
   * @param {String} id - reservation id - the reservation id to get
   * @return {Promise} promise that will resolve or reject with server response
   */
  function detail(id) {
    return _promiseWrapper(
      $http.get([endpoint, id].join('/'))
    );
  }

  /**
   * @typedef ReservationApiService.ReservationItems
   * @type {Object}
   * @property {String} eventId - event id
   * @property {Number} amount - amount of tickets to reserve
   */
  /**
   * Calls the create endpoint
   * @memberOf ReservationApiService
   * @public
   * @param {Array.<ReservationApiService.ReservationItems>} reservationItems - the items to be reserved
   * @return {Promise} promise that will resolve or reject with server response
   */
  function create(reservationItems) {
    return _promiseWrapper(
      $http.post(endpoint, {
        reservationItems: reservationItems
      })
    );
  }

  /**
   * Calls the update endpoint
   * @memberOf ReservationApiService
   * @public
   * @param {Object} data - reservation object
   * @return {Promise} promise that will resolve or reject with server response
   */
  function update(data) {
    return _promiseWrapper(
      $http.put(endpoint, data)
    );
  }

  /**
   * Calls the delete endpoint
   * @memberOf ReservationApiService
   * @public
   * @param {Number} id - id of the reservation object
   * @return {Promise} promise that will resolve or reject with server response
   */
  function cancel(id) {
    return _promiseWrapper(
      $http.delete([endpoint, id].join('/'))
    );
  }

  function _promiseWrapper(request) {
    var defer = $q.defer();

    request
      .then(
        _unWrapData(defer.resolve),
        _unWrapData(defer.reject)
      );

    return defer.promise;
  }

  function _unWrapData(callback) {
    return function (response) {
      return callback(response.data);
    };
  }

}

function ReservationApiServiceProvider() {}

ReservationApiServiceProvider.prototype.setEndpoint = function (endpoint) {
  this.endpoint = endpoint;
};

ReservationApiServiceProvider.prototype.$get = [
  '$http',
  '$q',
  'UtilsService',
  function($http, $q, UtilsService) {
    return new ReservationApiService(this.endpoint, $http, $q, UtilsService.debounce);
  }
];

ReservationApiServiceProvider.$inject = [];